<div class="modal-header">
    <h2 class="headline m-0" fxFlex="auto">{{register?'register':"login"|translate}}</h2>
    <button class="btn-close" aria-label="Close" (click)="dialogref.close()">
    </button>
</div>
<div class="modal-body">
        <form *ngIf="!register;else registerComponent" [formGroup]="form" (ngSubmit)="login()">
            <div class="form-group required">
                <label lass="control-label">{{"email_address"|translate}}</label>
                <input type="email" class="form-control" [placeholder]="'your_email'" formControlName="email" required>
                <div *ngIf="submitted && form.controls['email'].errors || form.controls['email'].invalid && (form.controls['email'].dirty || form.controls['email'].touched)"
                    class="alert alert-danger">
                    {{"enter_valid_email"|translate}}.
                    <div *ngIf="form.controls['email'].errors.required">
                        {{"email_required"|translate}}.
                    </div>
                </div>
            </div>
            <div class="form-group required">
                <label lass="control-label">{{"password"|translate}}</label>
                <input type="password" class="form-control" placeholder="Password" formControlName="password" required>
                <div *ngIf="submitted && form.controls['password'].errors || form.controls['password'].invalid && (form.controls['password'].dirty || form.controls['password'].touched)"
                    class="alert alert-danger">
                    <div *ngIf="form.controls['password'].errors.required">
                        {{"password_required"|translate}}.
                    </div>
                </div>
                <small class="form-text text-muted">
                    <a href="" routerLink="/forgot-password" >{{"forgot"|translate}}</a>
                </small>
            </div>
            <button type="submit" class="btn btn-primary mt-2 mt-md-3 mt-lg-4">{{"login"|translate}}</button>
            <button type="button" (click)="register = !register" class="btn btn-primary mt-2 mt-md-3 mt-lg-4">{{"create_account"|translate}}</button>

        </form>
        <ng-template #registerComponent>
                <app-register-componenet [bsRef]="dialogref" [loginForm]="loginForm"></app-register-componenet>
        </ng-template>


</div>
